<app-bread-crumbs [(breadcrumbs)]="breadcrumbs"></app-bread-crumbs>
@if (dealer) {
  <div class="container">
    <h1><app-header-icon iconName="contact_page"></app-header-icon>{{ 'CONTACTDATA' | translate }}</h1>
    <div class="contact-details-card">
      @if (dealer.dealer_name && dealer.dealer_name.length) {
        <h2 [innerHTML]="dealer.dealer_name"></h2>
      }
      @if (dealer.dealer_code && dealer.dealer_code.length) {
        <span class="code" [innerHTML]="dealer.dealer_code"></span>
      }
      @if (dealer.address.street && dealer.address.street.length) {
        <span class="street">
          @if (dealer.address.street && dealer.address.street.length) {
            <span [innerHTML]="dealer.address.street"></span>
          }
          @if (dealer.address.housenumber && dealer.address.housenumber.length) {
            <span [innerHTML]="' ' + dealer.address.housenumber"></span>
          }
          @if (dealer.address.housenumber_addition && dealer.address.housenumber_addition.length) {
            <span [innerHTML]="' ' + dealer.address.housenumber_addition"></span>
          }
        </span>
      }
      @if ((dealer.address.zip && dealer.address.zip.length) || (dealer.address.city && dealer.address.city.length)) {
        <span class="place">
          @if (dealer.address.zip && dealer.address.zip.length) {
            <span [innerHTML]="dealer.address.zip"></span>
          }
          @if (dealer.address.city && dealer.address.city.length) {
            <span [innerHTML]="' ' + dealer.address.city"></span>
          }
        </span>
      }
      @if (dealer.address.country && dealer.address.country.length) {
        <span class="country" [innerHTML]="dealer.address.country"></span>
      }
      @if (dealer.email && dealer.email.length) {
        <a href="mailto:{{dealer.email}}" class="email" [innerHTML]="dealer.email"></a>
      }
      @if (dealer.phone && dealer.phone.length) {
        <a href="tel:{{dealer.phone}}" class="phone" [innerHTML]="dealer.phone"></a>
      }
      @if (dealer.url && dealer.url.length) {
        <a [href]="dealer.url" class="url" [innerHTML]="dealer.url"></a>
      }
    </div>
  </div>
}
